import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileClock, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { formatCOP } from "@/components/common";

export default function ExpiringQuotes({ days = 15 }) {
  const navigate = useNavigate();
  const [quotes, setQuotes] = useState([]);
  useEffect(() => { api.get(`/quotes/expiring?days=${days}`).then(r => setQuotes(r.data)).catch(() => {}); }, [days]);
  if (quotes.length === 0) return null;
  return (
    <div data-testid="expiring-quotes" className="bg-[#15171E] border border-[#262A33] rounded-2xl p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <FileClock className="w-4 h-4 text-[#F97316]" strokeWidth={1.75}/>
          <h3 className="font-bold text-[#F5F5F7]" style={{ fontFamily: "Manrope, sans-serif" }}>Cotizaciones por vencer</h3>
          <span className="text-xs text-[#9CA3AF] ml-1">{quotes.length} sin respuesta · próximos {days} días</span>
        </div>
        <button onClick={() => navigate("/documentos?tab=cotizaciones")} className="text-xs text-[#F97316] hover:underline">Ver cotizaciones →</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {quotes.map(q => {
          const soon = !q.is_expired && q.days_left !== null && q.days_left <= 5;
          return (
            <button key={q.quote_id} data-testid={`expiring-quote-${q.quote_id}`} onClick={() => navigate("/documentos?tab=cotizaciones")}
              className={`text-left flex items-center gap-3 p-3 rounded-xl border transition-colors ${
                q.is_expired ? "bg-red-500/5 border-red-500/25 hover:bg-red-500/10" :
                soon ? "bg-amber-500/5 border-amber-500/25 hover:bg-amber-500/10" :
                "bg-[#0B0D12] border-[#262A33] hover:border-[#F97316]/40 hover:bg-[#1A1D24]"}`}>
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                q.is_expired ? "bg-red-500/10 text-red-400" : soon ? "bg-amber-500/10 text-amber-400" : "bg-[#F97316]/10 text-[#F97316]"}`}>
                {q.is_expired ? <AlertTriangle className="w-4 h-4"/> : <FileClock className="w-4 h-4"/>}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm text-[#F5F5F7] font-medium truncate">{q.client_name} · {formatCOP(q.total)}</div>
                <div className="text-[10px] text-[#9CA3AF] truncate">
                  {q.number}{q.title ? ` · ${q.title}` : ""} · Vence {q.valid_until}{" "}
                  {q.is_expired ? <span className="text-red-400 font-semibold">· VENCIDA hace {Math.abs(q.days_left)}d</span> :
                    q.days_left === 0 ? <span className="text-amber-400 font-semibold">· HOY</span> :
                    <span className={soon ? "text-amber-400 font-semibold" : "text-[#9CA3AF]"}>· en {q.days_left}d</span>}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
